import * as Yup from 'yup'

export const ValidationSchema = Yup.object().shape({
  name: Yup.string().required("Campo requerido"),
  textColor: Yup.string().nullable(),
  backgroundColor: Yup.string().nullable(),
  active: Yup.boolean().required("Campo requerido")
})